// "Deixar de ser Profissional": o proprio Profissional volta a Comum na hora (sem aprovacao).
// O servidor e a fonte da verdade; aqui ficam so os textos e a leitura da resposta.

export const TEXTOS_DEIXAR = {
  titulo: "Deixar de ser Profissional?",
  perde: "Você deixa de poder criar subgrupos e registrar novas áreas.",
  mantem: "O que você já criou continua seu e você segue editando.",
  volta: "Se mudar de ideia, é só pedir o perfil Profissional de novo.",
  sucesso: "Você voltou ao perfil Comum.",
  botao: "Deixar de ser Profissional",
  confirmar: "Deixar o perfil",
};

// Interpreta o resultado do model (resposta OU erro do axios, que nunca lanca).
//  - ok: virou Comum agora
//  - jaComum: o servidor diz que ja era Comum (tela desatualizada): tratar como Comum, sem erro
//  - aviso: regra de negocio (409 com codigo) -> mensagem amigavel, nao e falha
//  - erro: falha de verdade (rede, 5xx, 429)
export function interpretarDeixar(resultado) {
  const status = resultado?.status ?? resultado?.response?.status;
  const dados = resultado?.data ?? resultado?.response?.data ?? {};
  const mensagem = dados.message || dados.error || "";
  if (status >= 200 && status < 300) {
    return { tipo: "ok", mensagem: dados.message || TEXTOS_DEIXAR.sucesso, usuario: dados.usuario || null };
  }
  if (status === 409 && dados.codigo) {
    return { tipo: dados.codigo === "JA_COMUM" ? "jaComum" : "aviso", mensagem, codigo: dados.codigo };
  }
  return { tipo: "erro", mensagem: mensagem || "Não foi possível concluir agora. Tente novamente em instantes." };
}

// Sessao do navegador acompanha a store: o tipo novo vale ate no recarregar da pagina.
export function usuarioComoComum(usuario, resposta) {
  const base = { ...(usuario || {}) };
  if (resposta?.tipo) base.tipo = resposta.tipo;
  else base.tipo = "Comum";
  return base;
}

// A store NAO guarda o token; quem guarda e a sessao do navegador. Regravar a sessao com o
// usuario da store apagaria o token (as proximas chamadas virariam 401). Por isso o tipo novo
// e MESCLADO no objeto que ja esta na sessao, que mantem o token.
export function mesclarTipoNaSessao(jsonAtual, tipo = "Comum") {
  let atual = {};
  try { atual = JSON.parse(jsonAtual) || {}; } catch (e) { atual = {}; }
  return { ...atual, tipo };
}
